import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface IHistorySlice {
  currentPage: string;
  previousPage: string;
}

const initialState: IHistorySlice = {
  currentPage: "",
  previousPage: "",
};

export const historyRouteSlice = createSlice({
  name: "historyRoute",
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<string>) => {
      state.currentPage = action.payload;
    },
    setPreviousPage: (state, action: PayloadAction<string>) => {
      state.previousPage = state.currentPage;
    },
  },
});

export const {setCurrentPage,setPreviousPage} = historyRouteSlice.actions;
export default historyRouteSlice.reducer;
